module["exports"] = [
  "Pty Ltd",
  "and Sons",
  "Corp",
  "Group",
  "Brothers",
  "Partners"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en_au_ocker/company/suffix.js
// module id = 2202
// module chunks = 2